import { render, staticRenderFns } from "./DialogInputReasonRiskLevel.vue?vue&type=template&id=c1563fc8&"
import script from "./DialogInputReasonRiskLevel.vue?vue&type=script&lang=js&"
export * from "./DialogInputReasonRiskLevel.vue?vue&type=script&lang=js&"
import style0 from "./DialogInputReasonRiskLevel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports